import React from 'react'
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";

const EditIconWithLabel = ({ text, click, hasData }) => {

    const styles = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "10px auto",
    };

    return (<div style={styles}>
        <div>
            <div className="field"><label>{text}</label></div>
        </div>
        <div>
            <Icon link name='pencil' onClick={click} style={hasData ? { color: 'red' } : {}} />
        </div>
    </div>);
}

EditIconWithLabel.propTypes = {
    text: PropTypes.string,
    click: PropTypes.func,
    hasData: PropTypes.bool,
}

export default EditIconWithLabel